<template>
    <div>
        <canvas id="payCodeCanvas" width="512" height="512"></canvas>
    </div>
</template>

<script>
    import { isAndroid, isIOS } from 'mobile-device-detect';
    export default {
        props: {
            url: String
        },

        computed: {

        },

        methods: {
            createQrcode(text, typeNumber, errorCorrectionLevel, mode, mb) {
                qrcode.stringToBytes = qrcode.stringToBytesFuncs[mb];
                if (typeNumber == 0) {
                    typeNumber = this.suggestTypeNumber(text);
                }

                var qr = qrcode(typeNumber || 4, errorCorrectionLevel || 'M');
                qr.addData(text, mode);
                qr.make();

                return qr
            },

            suggestTypeNumber(text) {
                var length = text.length;
                if (length <= 32) { return 3; }
                else if (length <= 46) { return 4; }
                else if (length <= 60) { return 5; }
                else if (length <= 74) { return 6; }
                else if (length <= 86) { return 7; }
                else if (length <= 108) { return 8; }
                else if (length <= 130) { return 9; }
                else if (length <= 151) { return 10; }
                else if (length <= 177) { return 11; }
                else if (length <= 203) { return 12; }
                else if (length <= 241) { return 13; }
                else if (length <= 258) { return 14; }
                else if (length <= 292) { return 15; }
                else { return 40; }
            },

            encodeImageFileAsURL(element) {
                var file = element.files[0];
                var reader = new FileReader();
                reader.onloadend = function() {
                    var logo = document.getElementById('logo');
                    logo.src = reader.result;
                }
                reader.readAsDataURL(file);
            },

            updateQrcode() {
                var text = this.url;
                var t = 0;
                var e = 'Q';
                var m = 'Byte';
                var mb = 'UTF-8';
                var qr = this.createQrcode(text, t, e, m, mb);
                var size = 300;
                var consumer = false;

                var canvas = document.getElementById('payCodeCanvas');
                var ctx = canvas.getContext('2d');

                canvas.width = size;
                canvas.height = size;
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                drawPayCode(qr, canvas, 7, null, consumer);
            }


        },

        mounted() {
            this.updateQrcode();
        }
    }
</script>

<style scoped lang="scss">

</style>
